import {
  CouponRedemptionType,
  CouponResponseInt,
  CouponStatusType,
  SelfServePlan,
} from '@hcs/types';
import { formatKebabCase } from '@hcs/utils';

export const getCouponStatus = ({
  active_on,
  active_until,
}: CouponResponseInt): CouponStatusType => {
  let status: CouponStatusType = 'active';
  const now = new Date();
  if (active_on) {
    const activeOn = new Date(active_on);
    const activeUntil = active_until ? new Date(active_until) : null;
    if (now <= activeOn) {
      status = 'upcoming';
    } else if (activeUntil && now >= activeUntil) {
      status = 'expired';
    }
  }
  return status;
};

export const formatRedemptionType = (redemptionType: CouponRedemptionType) => {
  return formatKebabCase(redemptionType);
};

export const getPlanLabel = (plan?: SelfServePlan): string => {
  if (!plan) return '';
  return `${plan.name} ${plan.commit_period} (${plan.verified_agent_plan ? 'Agent' : 'Standard'})`;
};
